<template>
  <div v-if="loaded"
       class="page-account-security"
  >
    <ym-cell title="更换手机号"
             is-link
             :to="{ name: 'ModifyMobile' }"
    >
      <span class="desc">{{ mobile|formatMobile }}</span>
    </ym-cell>
    <ym-cell title="账号绑定"
             is-link
             :to="{ name: 'AccountBinding' }"
    >
    </ym-cell>
    <ym-cell title="修改登录密码"
             is-link
             :to="{ name: 'PasswordModify', query: { hasPassword: hasPassword } }"
    >
      <span class="desc">{{ hasPassword ? '修改' : '未设置' }}</span>
    </ym-cell>
    <div class="logoff"></div>
    <ym-cell title="注销账号"
             is-link
             :to="{name: 'AccountLogoff'}"
    >
      <span class="desc">注销后无法恢复，请谨慎</span>
    </ym-cell>
  </div>
</template>

<script>
  import { Cell } from '@ymba/ym-ui';
  import { getMyAccountInfo } from '@/services/user';

  export default {
    name: 'AccountSecurity',
    metaInfo: {
      title: '账号安全',
    },
    data() {
      return {
        loaded: false,
        mobile: '',
        hasPassword: false,
      };
    },
    components: {
      'ym-cell': Cell,
    },
    methods: {
      async fetchData() {
        const data = await getMyAccountInfo();
        this.mobile = data.mobile;
        this.hasPassword = data.hasPassword;
        this.loaded = true;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .desc {
    color: @color-text-lighter;
  }

  .logoff {
    min-height: 20px;
    background-color: #f4f4f4;
  }
</style>
